import { booleanPointInPolygon, point } from "@turf/turf";

import type { CoordsType } from "~/lib/map/types";

export const isCoordsInGeometry = (
  { lng, lat }: CoordsType,
  geometry: GeoJSON.Polygon | GeoJSON.MultiPolygon,
): boolean => booleanPointInPolygon(point([lng, lat]), geometry, { ignoreBoundary: true });
